import { render, staticRenderFns } from "./UiSecurityCodeModal.vue?vue&type=template&id=6a463df9&"
import script from "./UiSecurityCodeModal.vue?vue&type=script&lang=js&"
export * from "./UiSecurityCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports